// @ts-nocheck
import * as React from 'react';
import Chip from '@mui/material/Chip';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ScheduleIcon from '@mui/icons-material/Schedule';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Event from '@mui/icons-material/Event';

const config = {
    "Enviando":         { icon: <AccessTimeIcon />,        bg: '#FFF3E0', color: '#E65100', border: '#FFCC80' },
    "Fallo envio":      { icon: <ErrorOutlineIcon />,       bg: '#FDECEA', color: '#C62828', border: '#EF9A9A' },
    "Envio Demorado":   { icon: <WarningAmberIcon />,       bg: '#FFFDE7', color: '#F57F17', border: '#FFF176' },
    "Enviado":          { icon: <CheckCircleOutlineIcon />, bg: '#E8F5E9', color: '#2E7D32', border: '#A5D6A7' },
    "Envio Parcial":    { icon: <ScheduleIcon />,           bg: '#E3F2FD', color: '#1565C0', border: '#90CAF9' },
    "Envio Programado": { icon: <Event />,                  bg: '#EDE7F6', color: '#4527A0', border: '#B39DDB' },
};

export default function DifusionChip({ estado }) {
    const { icon: chipIcon, bg, color, border } = config[estado] ?? config["Enviando"];
    return (
        <Chip
            icon={React.cloneElement(chipIcon, { style: { color, fontSize: 18 } })}
            label={estado}
            sx={{
                backgroundColor: bg,
                color,
                border: `1px solid ${border}`,
                fontWeight: 600,
                fontSize: '0.85rem',
                height: 32,
                '& .MuiChip-icon': { marginLeft: '8px' },
            }}
        />
    );
}
